<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <td class="text-xs-center">
          <v-btn color="blue" @click="downloadBilletsList()" dark>
            <v-icon v-if="billetsBankBatch && !loadingSheet" class="mr-1">
              download
            </v-icon>
            <span v-if="!loadingSheet">Baixar Lista de Faturamento</span>
            <v-progress-circular
              v-if="loadingSheet"
              indeterminate
              color="white"
              size="17"
              class="mr-2"
            ></v-progress-circular>
            <span v-if="loadingSheet"> Gerando planilha...</span>
          </v-btn>
        </td>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="billetsBankBatch"
        :search="search"
        :pagination.sync="pag"
        no-data-text="Nenhuma conta encontrada"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.bar_code }}</td>
          <td class="text-xs-center">
            {{ props.item.total_invoice | formatCurrency }}
          </td>
          <td class="text-xs-center">{{ props.item?.xml_id }}</td>
          <td class="text-xs-center">{{ props.item?.competence }}</td>
          <td>
            <v-chip
              :color="props.item.status | billingBatchStatusColor"
              text-color="white"
            >
              {{ props.item.status | billingBatchStatus }}
            </v-chip>
            <v-chip
              v-if="props.item.status === 'payment_error'"
              color="error"
              text-color="white"
            >
              <v-icon slot="start" small>alert</v-icon>{{ props.item.error }}
            </v-chip>
          </td>
        </template>
        <template v-slot:no-data v-if="loadingBankBatchs">
          <div class="text-xs-center">
            Carregando tabela
            <v-progress-circular
              indeterminate
              color="#7C3DFF"
              size="17"
            ></v-progress-circular>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import XLSX from "xlsx";

export default {
  props: ["batch_id", "search_text"],
  data() {
    return {
      loadingSheet: false,
      search: "",
      color: "",
      snackMessage: "",
      snackbar: false,
      headers: [
        {
          text: "Código de Barras",
          align: "center",
          value: "bar_code",
        },
        {
          text: "Valor",
          align: "center",
          value: "total_invoice",
        },
        {
          text: "Nome",
          align: "center",
          value: "xml_id",
        },
        {
          text: "Competência",
          align: "center",
          value: "competence",
        },
        {
          text: "Status",
          align: "center",
          value: "status",
        },
      ],
      pag: {
        rowsPerPage: 100,
      },
    };
  },

  async mounted() {
    if (!this.billetsBankBatch || this.billetsBankBatch.length <= 0) {
      await this.getBilletsBankBatch(this.batch_id);
      this.search = this.search_text;
    }
  },

  computed: {
    ...mapState("uniquebilling", [
      "billetsBankBatch",
      "getBillings",
      "loadingBankBatchs",
    ]),
  },
  watch: {
    batch_id() {
      this.getBilletsBankBatch(this.batch_id);
    },
    search_text() {
      this.search = this.search_text;
    },
  },

  methods: {
    ...mapActions("uniquebilling", ["getBilletsBankBatch", "getSheetData"]),

    showSnackBar(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    async downloadBilletsList() {
      try {
        this.loadingSheet = true;
        const billetsListCsv = [
          [
            "Competência",
            "Total",
            "Unidade Consumidora",
            "Usina",
            "Status",
            "Data de Emissão",
            "Nº Fat ou Docum.",
            "Data de Pagamento",
          ],
        ];

        const sd = await this.getSheetData(this.batch_id);
        for (let i = 0; i < sd.length; i++) {
          const rowData = [
            sd[i].competence,
            sd[i].total_invoice,
            sd[i].uc,
            sd[i].ufv_name,
            sd[i].status,
            sd[i].emissao,
            sd[i].nota_fiscal,
            sd[i].paid_at,
          ];

          billetsListCsv.push(rowData);
        }
        // Download EXCEL
        const ws = XLSX.utils.aoa_to_sheet(billetsListCsv);
        const wb = XLSX.utils.book_new();
        const file = "Lote-" + this.batch_id;
        XLSX.utils.book_append_sheet(wb, ws, file);
        XLSX.writeFile(wb, file + ".xlsx");
        this.showSnackBar("Lista de faturamento gerada com sucesso.", "green");
        this.loadingSheet = false;
      } catch (err) {
        this.showSnackBar(
          "Não foi possível fazer o download da lista de faturamentos." +
            err.message,
          "red",
        );
      }
    },
  },

  filters: {
    formatCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },

    formatDate(value) {
      if (!value) return "";
      const timestamp = value;
      const myDate = new Date(timestamp._seconds * 1000);

      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
};
</script>
